const ConstsDict = {
    currentSemester: 2,
    semesterFirstDay: {
        year: "2026",
        month: "04",
        day: "12",
        dayOfWeek: 1 // 1 = Sunday, 2 = Monday, 3 = Tuesday, etc.
    },
    semesterLastDay: {
        year: "2026",
        month: "07",
        day: "07"
    }
};

export default ConstsDict;
